import { render, staticRenderFns } from "./AdvertisingMessage.html?vue&type=template&id=21cf4a0c&lang=html&external"
import script from "./AdvertisingMessage.vue?vue&type=script&lang=js"
export * from "./AdvertisingMessage.vue?vue&type=script&lang=js"
import style0 from "./AdvertisingMessage.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports